import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的韩国漫画</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50/60 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}